import React from "react";

import SavingsIcon from "@mui/icons-material/Savings";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

const offers = [
  { icon: SavingsIcon, title: "Најповолни цени" },
  { icon: LocalShippingIcon, title: "Брза достава" },
  { icon: PhoneIphoneIcon, title: "Професионален сервис" },
  { icon: AlarmOnIcon, title: "Брза дијагностика" },
  { icon: WorkspacePremiumIcon, title: "Премиум корисничко искуство" },
];

function OurOffers() {
  return (
    <section className="marquee">
      <div className="container">
        <div className="marquee__container marquee__container--desktop">
          {offers.map((offer) => {
            const Icon = offer.icon;

            return (
              <div className="marquee__item" key={offer.title}>
                <div className="marquee__icon-wrap">
                  <Icon />
                </div>
                <p>{offer.title}</p>
              </div>
            );
          })}
        </div>
        <div className="marquee__mobile">
          <div className="marquee__track">
            {[...offers, ...offers].map((offer, index) => {
              const Icon = offer.icon;

              return (
                <div className="marquee__item" key={`${offer.title}-${index}`}>
                  <div className="marquee__icon-wrap">
                    <Icon />
                  </div>
                  <p>{offer.title}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurOffers;
